import React, { useState } from 'react';
import { Card } from 'ui-toolkit';
import { IThirdPartyContactData } from '../../../types/contacts/IThirdPartyContact';
import { AddThirdPartyContactForm } from '../../../components/order/contacts/thirdPartyOrderContacts/AddThirdPartyContactForm';
import { ThirdPartyContactsTable } from '../../../components/order/contacts/thirdPartyOrderContacts/ThirdPartyContactsTable';
import { EditThirdPartyContactForm } from '../../../components/order/contacts/thirdPartyOrderContacts/EditThirdPartyContactForm';
import { IContactsPageProps } from './ClientContactsPage';
import { ContactsPageTemplate } from './subComponents/ContactsPageTemplate';
import { useListContactFunctionsQuery } from '../../../API/contacts/ContactFunctionsApi';
import { Show } from '../../../components/shared/Show';

interface IThirdPartyContactsPageProps extends IContactsPageProps {
  thirdPartyContacts: IThirdPartyContactData[];
  onAddNewContact: (data: IThirdPartyContactData) => void;
  onUpdateContact: (data: IThirdPartyContactData) => void;
}

export const ThirdPartyContactsPage: React.FC<IThirdPartyContactsPageProps> = ({
  thirdPartyContacts,
  onAddNewContact,
  onUpdateContact,
  onDeleteContact,
  onResetAddContact,
  onResetUpdateContact,
  addFetchError,
  addFetchStatus,
  updateFetchStatus,
  updateFetchError,
  deleteFetchStatus,
  deleteFetchError,
  loading,
  onResetDeleteContact,
}) => {
  const [showAddContactForm, setShowAddContactForm] = useState(false);
  const [editContact, setEditContact] = useState<IThirdPartyContactData | null>(null);
  const { data: contactFunctions = [] } = useListContactFunctionsQuery();

  const onCancelAddContactForm = () => {
    setShowAddContactForm(false);
    onResetAddContact();
  };
  const onCancelEditContactForm = () => {
    setEditContact(null);
    onResetUpdateContact();
  };

  return (
    <Card>
      <ContactsPageTemplate
        hintText={'Points of contact for the client.'}
        header={'3rd Party Contacts'}
        addContact={() => setShowAddContactForm(true)}
      >
        <Show when={contactFunctions.length !== 0}>
          <ThirdPartyContactsTable
            data={thirdPartyContacts}
            loading={loading}
            onEditContact={setEditContact}
            contactFunctions={contactFunctions}
          />
        </Show>
      </ContactsPageTemplate>
      {showAddContactForm && (
        <AddThirdPartyContactForm
          onSubmit={onAddNewContact}
          onCancel={onCancelAddContactForm}
          addFetchStatus={addFetchStatus}
          addFetchError={addFetchError}
        />
      )}
      {editContact && (
        <EditThirdPartyContactForm
          initialData={editContact}
          onSubmit={onUpdateContact}
          onCancel={onCancelEditContactForm}
          updateFetchStatus={updateFetchStatus}
          updateFetchError={updateFetchError}
          onDelete={onDeleteContact}
          deleteFetchStatus={deleteFetchStatus}
          deleteFetchError={deleteFetchError}
          onResetDeleteContact={onResetDeleteContact}
        />
      )}
    </Card>
  );
};
